module.exports = __webpack_public_path__ + "img/Retention-risks.6a900ee5.png";